import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import TopNavbarBack from "../../components/TopNavbarBack";
import LoadingComp from "../../components/LoadingComp";
import GoToTop from "../../components/GoToTop";
import Navbar from "../../components/Navbar";
import { useFetch } from "../../custom/api";
import { notifyUnlocked } from "../../components/achievements/AchievementUnlockToast";
import { formatJalali } from "../challenges/jalaliDate";
import { toFarsiNumber } from "../../custom/helpers";
import "../../styles/Containers.css";
import "../../styles/Buttons.css";
import "../../styles/Challenges.css";
import "../../styles/Achievements.css";

// Minimal Community feed - just enough real UI for the Community
// Starter/Contributor achievements to be earned through actual use.
export default function Community() {
  const { myFetch } = useFetch();
  const isLoggedIn = !!localStorage.getItem("token");
  const [posts, setPosts] = useState(null); // null = loading
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [content, setContent] = useState("");
  const [posting, setPosting] = useState(false);

  const loadPage = async (nextPage) => {
    const resp = await myFetch(`community/posts?page=${nextPage}`, { method: "GET" });
    const r = await resp.json();
    setTotalPages(r.total_pages || 1);
    setPosts((prev) => (nextPage === 1 || !prev ? r.items : [...prev, ...r.items]));
    setPage(nextPage);
  };

  useEffect(() => {
    loadPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async () => {
    if (!content.trim() || posting) return;
    setPosting(true);
    try {
      const resp = await myFetch(`community/posts`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ content: content.trim() }),
      });
      const r = await resp.json();
      if (r.status === "success") {
        setContent("");
        toast.success("پست شما منتشر شد");
        loadPage(1);
        if (r.newly_unlocked && r.newly_unlocked.length > 0) notifyUnlocked(r.newly_unlocked);
      } else {
        toast.error(r.message || "مشکلی پیش اومد، دوباره امتحان کن");
      }
    } finally {
      setPosting(false);
    }
  };

  const handleLike = async (post) => {
    if (post.is_mine || post.liked_by_me) return;
    const resp = await myFetch(`community/posts/${post.post_id}/like`, { method: "POST" });
    const r = await resp.json();
    if (r.status === "success") {
      setPosts((prev) =>
        prev.map((p) =>
          p.post_id === post.post_id ? { ...p, likes_count: r.likes_count, liked_by_me: true } : p
        )
      );
    } else {
      toast.error(r.message || "این کار الان ممکن نیست");
    }
  };

  return (
    <div className="backLightColor">
      <TopNavbarBack
        title="انجمن"
        rbuttonIcon={["icon-iconchevron-right"]}
        rbackground={["rectangle1"]}
        lbuttonIcon={["dNone"]}
        lbuttonHref={["null"]}
        lbackground={["null"]}
      />

      <div className="main-container">
        {isLoggedIn && (
          <div className="b-white padding5 radius1-5 shadow-smooth">
            <textarea
              className="communityInput yekan"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder="چی تو ذهنته؟"
              rows={3}
              maxLength={1000}
            />
            <button
              type="button"
              className="primaryPurple width100 marginTop5"
              disabled={posting || !content.trim()}
              onClick={handleSubmit}
            >
              {posting ? "در حال ارسال..." : "انتشار"}
            </button>
          </div>
        )}

        {posts === null ? (
          <LoadingComp />
        ) : posts.length === 0 ? (
          <p className="caption-1 grey-2 centerAlign yekan">هنوز پستی منتشر نشده. اولین نفر باش!</p>
        ) : (
          <div>
            {posts.map((post) => (
              <div
                key={post.post_id}
                className="b-white padding5 radius1-5 shadow-smooth marginBottom1r communityPost"
              >
                <div className="spc-between">
                  <p className="subject-1 yekan" style={{ fontWeight: "bold" }}>
                    {post.name || "کاربر فودپلنر"}
                  </p>
                  <p className="caption-2 grey-2 yekan">{formatJalali(post.created_at, "DD MMMM")}</p>
                </div>
                <p className="yekan grey-1 rightAlign marginTop5">{post.content}</p>
                <div className="spc-between marginTop5">
                  <button
                    type="button"
                    className={`communityLikeBtn caption-1 yekan ${
                      post.liked_by_me ? "communityLikeBtn-active" : ""
                    }`}
                    disabled={post.is_mine || post.liked_by_me}
                    onClick={() => handleLike(post)}
                  >
                    {post.liked_by_me ? "❤️" : "🤍"} {toFarsiNumber(post.likes_count || 0)}
                  </button>
                  {post.is_mine && <span className="caption-2 grey-2 yekan">پست شما</span>}
                </div>
              </div>
            ))}

            {page < totalPages && (
              <button
                type="button"
                className="challengeCheckinSecondary width100 marginTop5"
                disabled={loadingMore}
                onClick={async () => {
                  setLoadingMore(true);
                  await loadPage(page + 1);
                  setLoadingMore(false);
                }}
              >
                {loadingMore ? "در حال بارگذاری..." : "نمایش بیشتر"}
              </button>
            )}
          </div>
        )}
      </div>

      <Navbar />
      <GoToTop />
    </div>
  );
}
